// extracted by mini-css-extract-plugin
export default {"tab":"TemplatesManager__tab__RbkJM","toolbar":"TemplatesManager__toolbar__tgTKj","name":"TemplatesManager__name__TJ3EB","muted":"TemplatesManager__muted__VH3Nh"};